import _ from 'lodash'

const errorOption = {
  type: 'error',
  className: 'pega-width-20-rem pega-toasted-vertical pega-toasted-error pega-pre-wrap'
}

const rightTop = {
  position: 'top-right'
}

const registerToasted = (toasted) => {
  toasted.register('success', (payload) => {
    if (!payload.message) {
      return '成功しました'
    }
    return payload.message
  })
  toasted.register('successRightTopSingleton', (payload) => {
    // 他のトーストを削除(clearでもよかったのだが描画の動きが気になったため)
    toasted.toasts.forEach(toast => {
      !_.includes(_.get(toast, 'el.classList', []), 'error') && toast.remove()
    })
    if (!payload.message) {
      return '成功しました'
    }
    return payload.message
  }, rightTop)
  toasted.register('error', (payload) => {
    if (!payload.message) {
      return 'エラーが発生しました'
    }
    return payload.message
  }, errorOption)
  toasted.register('errorRightTop', (payload) => {
    if (!payload.message) {
      return 'エラーが発生しました'
    }
    return payload.message
  }, Object.assign({}, errorOption, rightTop))
}

export {
  registerToasted
}
